import * as moment from 'moment';
/**
 * calculate availability hours
 * note: we format date using the user's local timezone
 * @param availability Availability
 * @param translate t function
 * @returns {{isInPeriod: boolean, isFuturePeriodAvailable: boolean, availabilityDescription: string}}
 */
export var calculateAvailability = function (availability, translate) {
    if (translate === void 0) { translate = function (key) { return key; }; }
    if (!availability || !availability.onlinePeriods) {
        return {
            isInPeriod: false,
            isFuturePeriodAvailable: false,
            availabilityDescription: translate('AWAY'),
        };
    }
    var now = Date.now();
    var isInPeriod = availability.onlinePeriods.some(function (period) { return period.start < now && period.end > now; });
    var isFuturePeriodAvailable = availability.onlinePeriods.some(function (period) { return period.start > now; });
    var availabilityDescription;
    if (isInPeriod) {
        var nextPeriodEnd = calculateEndTimeOfLatestAdjacentPeriod(availability.onlinePeriods);
        if (nextPeriodEnd < aWeekFromNow()) {
            availabilityDescription = translate('ONLINE_UNTIL') + " " + formatDate(nextPeriodEnd, translate);
        }
        else {
            availabilityDescription = translate('ONLINE');
        }
    }
    else {
        var nextPeriod = availability.onlinePeriods[0];
        if (nextPeriod && nextPeriod.start < aWeekFromNow()) {
            var nextPeriodStart = new Date(nextPeriod.start);
            availabilityDescription = translate('AWAY_UNTIL') + " " + formatDate(nextPeriodStart, translate);
        }
        else {
            availabilityDescription = translate('AWAY');
        }
    }
    return {
        isInPeriod: isInPeriod,
        isFuturePeriodAvailable: isFuturePeriodAvailable,
        availabilityDescription: availabilityDescription,
    };
};
function calculateEndTimeOfLatestAdjacentPeriod(onlinePeriods) {
    var nextPeriod = onlinePeriods[0];
    if (onlinePeriods.length > 1 && nextPeriod.end === onlinePeriods[1].start) {
        return calculateEndTimeOfLatestAdjacentPeriod(onlinePeriods.slice(1));
    }
    return nextPeriod.end;
}
function formatDate(date, translate) {
    //format date using the user's local timezone
    var momentDate = moment(date);
    var day = translate(getDayOfWeekKey(momentDate.day()));
    var time = moment(momentDate).format('LT');
    var isSameDayOfWeek = moment(new Date()).day() === momentDate.day();
    return isSameDayOfWeek ? "" + time : day + " " + translate('AT_TIME') + " " + time;
}
var getDayOfWeekKey = function (index) {
    switch (index) {
        case 0:
            return 'DAY_SHORT_SUN';
        case 1:
            return 'DAY_SHORT_MON';
        case 2:
            return 'DAY_SHORT_TUE';
        case 3:
            return 'DAY_SHORT_WED';
        case 4:
            return 'DAY_SHORT_THU';
        case 5:
            return 'DAY_SHORT_FRI';
        case 6:
            return 'DAY_SHORT_SAT';
        default:
            return;
    }
};
var aWeekFromNow = function () {
    return new Date(new Date().setDate(new Date().getDate() + 7)).getTime();
};
export var availabilityHours = {
    calculateAvailability: calculateAvailability,
};
//# sourceMappingURL=availability-hours.js.map